import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom'
import Main from '../pages/main'
import Login from '../pages/login'
import WordCloud from '../pages/wordcloud'
import ChineseSeg from '../pages/chinese-seg'
import Sentiment from '../pages/sentiment'
import GenerateAccount from '../pages/generate-account'

export const routes = [
    {
        path: '/',
        Component: Main,
        children: [
            {
                path: '/',
                element: <Navigate to="/wordcloud" replace />,
            },
            {
                path: 'wordcloud',
                pathName: '词云生成',
                Component: WordCloud,
            },
            {
                path: 'chinese-seg',
                pathName: '中文分词',
                Component: ChineseSeg,
            },
            // {
            //     path: 'english-seg',
            //     pathName: '英文分词',
            //     Component: EnglishSeg,
            // },
            {
                path: 'sentiment',
                pathName: '评论分析',
                Component: Sentiment,
            },
            {
                path: 'generate-account',
                pathName: '生成账号',
                Component: GenerateAccount,
            },
            // {
            //     path: 'topic',
            //     pathName: '主题分析',
            //     Component: Topic,
            // },
        ],
    },
    {
        path: '/login',
        Component: Login,
    },
]

export default createBrowserRouter(routes)
